/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：149
 */

"use strict"

export { _5DC5FBFF as b }
export { IconWidgetSlider as d }
export { i as f }
export { a as e }
export { Https__static$bcmcdn$com_coco_image_slider_default_handle_image$pngV2 as c }
export { Https__static$bcmcdn$com_coco_image_slider_default_background_image$pngV2 as a }
export { Https__static$bcmcdn$com_coco_image_slider_default_track_image$pngV2 as g }
var /* [auto-meaningful-name] */_5DC5FBFF = "#5DC5FBFF"
var /* [auto-meaningful-name] */IconWidgetSlider = "icon-widget-slider"
var i = false
var a = false
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_slider_default_handle_image$pngV2 = "https://static.bcmcdn.com/coco/image/slider_default_handle_image.png?v=2"
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_slider_default_background_image$pngV2 = "https://static.bcmcdn.com/coco/image/slider_default_background_image.png?v=2"
var /* [auto-meaningful-name] */Https__static$bcmcdn$com_coco_image_slider_default_track_image$pngV2 = "https://static.bcmcdn.com/coco/image/slider_default_track_image.png?v=2"
export default Https__static$bcmcdn$com_coco_image_slider_default_background_image$pngV2
